import React, { useState } from 'react';
import './LoginPage.css'; // Reuse Login styles
import Carousel from './Carousel';
import slide1 from './assets/slide1.png';
import slide3 from './assets/slide3.png';
import slide4 from './assets/slide4.png';
import slide5 from './assets/slide5.png';
import { Link } from 'react-router-dom';
import { getApiBaseUrl } from './apiBaseUrl';

const slides = [
    { image: slide3, text: "Instant Eligibility Check" },
    { image: slide4, text: "Zero Paperwork" },
    { image: slide5, text: "Fast & Secure" },
    { image: slide1, text: "Get Started Today" }
];

const EligibilityPage = () => {
    const [formData, setFormData] = useState({
        aadhaar: '',
        pan: '',
        mobile: '',
        otp: ''
    });

    const [otpSent, setOtpSent] = useState(false);
    const [checkingEligibility, setCheckingEligibility] = useState(false);
    const [eligibilityResult, setEligibilityResult] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        message: '',
        type: 'info'
    });

    const showPopup = (message, type = 'info') => {
        setPopup({ show: true, message, type });
    };

    const closePopup = () => {
        setPopup((prev) => ({ ...prev, show: false }));
    };

    const recordLead = async (mobile, pan = '') => {
        if (!mobile || mobile.length !== 10) return;
        try {
            const baseUrl = getApiBaseUrl();
            await fetch(`${baseUrl}/api/record-lead`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    mobile,
                    pan,
                    kioskId: process.env.REACT_APP_KIOSK_ID
                })
            });
        } catch (err) {
            console.warn("Lead capture failed (silent)", err);
        }
    };

    // Lead Capture Logic
    React.useEffect(() => {
        let timer;
        if (formData.mobile.length === 10) {
            recordLead(formData.mobile, formData.pan);
            timer = setTimeout(() => {
                recordLead(formData.mobile, formData.pan);
            }, 60000);
        }
        return () => clearTimeout(timer);
    }, [formData.mobile, formData.pan]);


    // const navigate = useNavigate(); // Unused

    const handleChange = (e) => {
        let { name, value } = e.target;

        // Input Masks/Validation
        if (name === 'aadhaar') {
            // Allow only numbers, max 12
            value = value.replace(/\D/g, '').slice(0, 12);
        } else if (name === 'pan') {
            // Uppercase, max 10
            value = value.toUpperCase().slice(0, 10);
        } else if (name === 'mobile') {
            // Numbers only, max 10
            value = value.replace(/\D/g, '').slice(0, 10);
        } else if (name === 'otp') {
            // Numbers only, max 4
            value = value.replace(/\D/g, '').slice(0, 4);
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleSendOtp = () => {
        if (formData.mobile.length !== 10) {
            showPopup("Please enter a valid 10-digit mobile number.", "error");
            return;
        }
        // Simulate OTP send
        showPopup(`OTP sent to ${formData.mobile}`, "success");
        setOtpSent(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (formData.aadhaar.length !== 12) {
            showPopup("Aadhaar number must be 12 digits.", "error");
            return;
        }
        if (formData.pan.length !== 10) {
            showPopup("PAN number must be 10 characters.", "error");
            return;
        }

        if (otpSent && formData.otp) {
            setCheckingEligibility(true);
            setEligibilityResult(null);
            try {
                const baseUrl = getApiBaseUrl();
                const response = await fetch(`${baseUrl}/api/check-eligibility`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        aadhaar: formData.aadhaar,
                        pan: formData.pan,
                        mobile: formData.mobile
                    })
                });
                const data = await response.json();
                if (!response.ok || !data.success) {
                    showPopup(data.message || data.error || "Eligibility check failed.", "error");
                    return;
                }
                setEligibilityResult(data);
            } catch (error) {
                console.error("Eligibility check failed:", error);
                showPopup("Unable to check eligibility right now.", "error");
            } finally {
                setCheckingEligibility(false);
            }
        } else {
            showPopup("Please verify OTP first.", "error");
        }
    };

    return (
        <div className="login-page">
            {checkingEligibility && (
                <div className="app-page-loader-overlay" aria-live="polite" aria-busy="true">
                    <div className="app-page-loader-card">
                        <span className="app-page-loader-spinner" aria-hidden="true"></span>
                        <p>Checking your eligibility...</p>
                    </div>
                </div>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box ${popup.type}`}>
                        <div className="popup-icon">
                            {popup.type === 'success' ? '✓' : popup.type === 'error' ? '✕' : '!'}
                        </div>
                        <p>{popup.message}</p>
                        <button onClick={closePopup}>OK</button>
                    </div>
                </div>
            )}
            <div className="login-carousel-container">
                <Carousel slides={slides} interval={3500} />
            </div>

            <div className="login-form-container">
                <div className="form-wrapper">
                    {/* Reuse/Update Brand Tag */}
                    <img src={process.env.PUBLIC_URL + '/fintech_cloud_logo.svg'} alt="Finncube" style={{ height: '60px', borderRadius: '8px', marginBottom: '20px', display: 'block', margin: '0 auto 20px' }} />
                    <h2>Check Eligibility</h2>
                    <p className="subtitle">Enter your details to check loan eligibility.</p>

                    <form onSubmit={handleSubmit} autoComplete="off">
                        {/* Mobile Number & Send OTP (Now First) */}
                        <div className="form-group">
                            <label htmlFor="mobile">Mobile Number</label>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <input
                                    type="tel"
                                    id="mobile"
                                    name="mobile"
                                    placeholder="9876543210"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                    style={{ flex: 1 }}
                                    inputMode="none"
                                    data-layout="numeric"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck="false"
                                />
                                <button
                                    type="button"
                                    className="secondary-btn"
                                    style={{ padding: '0 20px', fontSize: '0.9rem', whiteSpace: 'nowrap', borderRadius: '12px', width: 'auto', background: 'rgba(255,255,255,0.1)' }}
                                    onClick={handleSendOtp}
                                >
                                    {otpSent ? 'Resend OTP' : 'Send OTP'}
                                </button>
                            </div>
                        </div>

                        {/* OTP Input - Conditional */}
                        {otpSent && (
                            <div className="form-group slide-down">
                                <label htmlFor="otp">Enter OTP</label>
                                <input
                                    type="text"
                                    id="otp"
                                    name="otp"
                                    placeholder="Enter 4-digit OTP"
                                    value={formData.otp}
                                    onChange={handleChange}
                                    required={otpSent}
                                    maxLength="4"
                                    inputMode="none"
                                    data-layout="numeric"
                                    autoComplete="one-time-code"
                                />
                            </div>
                        )}

                        {/* Aadhaar Number */}
                        <div className="form-group">
                            <label htmlFor="aadhaar">Aadhaar Number</label>
                            <input
                                type="text"
                                id="aadhaar"
                                name="aadhaar"
                                placeholder="12-digit Aadhaar Number"
                                value={formData.aadhaar}
                                onChange={handleChange}
                                required
                                inputMode="none"
                                data-layout="numeric"
                                autoComplete="new-password"
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                            />
                        </div>

                        {/* PAN Number */}
                        <div className="form-group">
                            <label htmlFor="pan">PAN Number</label>
                            <input
                                type="text"
                                id="pan"
                                name="pan"
                                placeholder="10-digit PAN Number"
                                value={formData.pan}
                                onChange={handleChange}
                                required
                                autoComplete="new-password"
                                autoCorrect="off"
                                autoCapitalize="characters"
                                spellCheck="false"
                                inputMode="none"
                                data-layout="alphanumeric"
                            />
                        </div>


                        <button type="submit" className="login-btn" disabled={checkingEligibility}>
                            {checkingEligibility ? 'Checking Eligibility...' : 'Check Eligibility'}
                        </button>

                        {eligibilityResult && (
                            <div style={{ marginTop: '18px', padding: '16px', borderRadius: '14px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#fff' }}>
                                    <span>Credit Score</span>
                                    <strong>{eligibilityResult.cibil ?? '--'}</strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#cbd5e1', fontSize: '0.92rem' }}>
                                    <span>Eligibility</span>
                                    <strong style={{ color: eligibilityResult.isEligible ? '#86efac' : '#fca5a5' }}>
                                        {eligibilityResult.isEligible ? 'Eligible' : 'Needs Review'}
                                    </strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#cbd5e1', fontSize: '0.92rem' }}>
                                    <span>Inquiry Ref</span>
                                    <strong>{eligibilityResult.inquiryRefNo || '--'}</strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cbd5e1', fontSize: '0.92rem' }}>
                                    <span>Status</span>
                                    <strong>{eligibilityResult.bureauStatus || '--'}</strong>
                                </div>
                            </div>
                        )}

                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <Link to="/" style={{ color: '#94a3b8', fontSize: '0.9rem', textDecoration: 'none' }}>← Back to Start</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EligibilityPage;
